module.exports = __webpack_public_path__ + "img/scroll-top-arrow.42aa68b5.png";